export { HomePageComponent } from './home-page/home-page.component';
export { AboutPageComponent } from './about-page/about-page.component';
export { NewsPageComponent } from './news-page/news-page.component';
export { ArticlePageComponent } from './article-page/article-page.component';
export { EventsPageComponent } from './events-page/events-page.component';
export { LoginPageComponent } from './login-page/login-page.component';
